import * as React from 'react';

export default function Security(props) {
  const { width = 150, height = 150, primary } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 200 200">
      <defs>
        <clipPath id="clip-MFA">
          <path d="M0 0H200V200H0z"></path>
        </clipPath>
      </defs>
      <g id="MFA" clipPath="url(#clip-MFA)">
        <path
          id="Path_62278"
          fill="#020d88"
          d="M212.259 23.424L130.161.244a6.5 6.5 0 00-3.524 0l-82.1 23.181a5.827 5.827 0 00-4.37 5.528v85c0 11.055 4.755 22.372 14.133 33.636 7.163 8.6 17.072 17.242 29.453 25.676a268.986 268.986 0 0042.139 23.224 6.479 6.479 0 005.011 0 268.993 268.993 0 0042.139-23.224c12.38-8.435 22.289-17.073 29.452-25.676 9.378-11.264 14.133-22.581 14.133-33.636v-85a5.825 5.825 0 00-4.368-5.529zm-7.894 90.524c0 19.565-20.858 37.91-38.355 49.855a263.841 263.841 0 01-37.61 21.037 263.838 263.838 0 01-37.612-21.04c-17.5-11.945-38.356-30.29-38.356-49.855v-80.7L128.4 11.8l75.966 21.449z"
          data-name="Path 62278"
          transform="translate(-28.398 3.011)"></path>
        <path
          id="primary"
          fill={primary}
          d="M76.311 32.457h-4.558v-8.38c0-11.565-10.21-20.951-22.79-20.951s-22.79 9.386-22.79 20.951v8.38h-4.557c-5.014 0-9.116 3.771-9.116 8.38v41.9c0 4.609 4.1 8.38 9.116 8.38h54.7c5.014 0 9.116-3.771 9.116-8.38v-41.9c-.005-4.609-4.107-8.38-9.121-8.38zm-13.218 0H34.834v-8.38c0-7.165 6.336-12.99 14.13-12.99s14.13 5.824 14.13 12.99z"
          opacity="0.4"
          transform="translate(51.036 44.692)"></path>
      </g>
    </svg>
  );
}
